"use strict";
exports.__esModule = true;
exports.toBanner = void 0;
var utils_1 = require("@lglp/utils");
var fields_1 = require("../fields");
var toBanner = function (data, logger) {
    var prismicBanner = utils_1.unprefix('banner', data);
    if (prismicBanner) {
        return utils_1.compact({
            label: logger.required(fields_1.toText(prismicBanner.title)),
            description: fields_1.toText(prismicBanner.description),
            image: fields_1.toImage(prismicBanner.image, logger)
        });
    }
};
exports.toBanner = toBanner;
//# sourceMappingURL=banner.js.map